import { render, staticRenderFns } from "./ModalBack.vue?vue&type=template&id=2d0ab531"
import script from "./ModalBack.vue?vue&type=script&lang=js"
export * from "./ModalBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports